export default function BuildingNull(props) {

    return (
   null
    )

}